import { render, staticRenderFns } from "./renegociacao_detalhe_devedor.vue?vue&type=template&id=2ba719f9"
import script from "./renegociacao_detalhe_devedor.vue?vue&type=script&lang=js"
export * from "./renegociacao_detalhe_devedor.vue?vue&type=script&lang=js"
import style0 from "./renegociacao_detalhe_devedor.vue?vue&type=style&index=0&id=2ba719f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports